module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--5-9aaab70d2d92502f1887aaeae661fd49.jpg";